import React from "react";
import Error from "../assets/404.svg";
const ErrorPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img src={Error} alt="Error" />
    </div>
  );
};

export default ErrorPage;
